import { FilterBar, SelectV2, SortDropdownValue } from "@/modules/common/components";
import { EntityFilterBar, UseFiltersResult } from "@/modules/common/filters";
import {
  AdminManagementCompanyManagerUserSortField,
  MANAGER_USER_ROLE_OPTIONS,
  MANAGER_USER_STATUS_OPTIONS,
  ManagerUserRole,
  ManagerUserStatus,
} from "@/modules/common/types/ManagerUsers.enum";
import { ListAdminManagementCompaniesManagerUsersDto } from "@/service/dto/admin-management-companies";

import { MANAGER_USER_FILTER_FIELDS } from "../../../../../constants/ManagerUserFilterFields";

const MANAGER_USER_SORT_OPTIONS = [
  { field: AdminManagementCompanyManagerUserSortField.NAME, label: "Nome" },
  { field: AdminManagementCompanyManagerUserSortField.CREATED_AT, label: "Data de criação" },
  { field: AdminManagementCompanyManagerUserSortField.LAST_LOGIN_AT, label: "Último acesso" },
];

interface ManagerUsersTabFilterBarProps {
  filters: UseFiltersResult<ListAdminManagementCompaniesManagerUsersDto>;
  sort: SortDropdownValue<AdminManagementCompanyManagerUserSortField> | null;
  onSortChange: (sort: SortDropdownValue<AdminManagementCompanyManagerUserSortField> | null) => void;
}

const ManagerUsersTabFilterBar = ({ filters, sort, onSortChange }: ManagerUsersTabFilterBarProps) => {
  return (
    <EntityFilterBar
      filters={filters}
      sort={sort}
      onSortChange={onSortChange}
      sortOptions={MANAGER_USER_SORT_OPTIONS}
      filterFields={MANAGER_USER_FILTER_FIELDS}
      modalTitle="Filtrar Usuários"
      searchPlaceholder="Pesquisar por nome ou e-mail..."
    >
      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Perfil"
          options={MANAGER_USER_ROLE_OPTIONS}
          value={filters.values.role !== undefined ? String(filters.values.role) : undefined}
          onChange={(next) => filters.setValue("role", next !== undefined ? (Number(next) as ManagerUserRole) : undefined)}
        />
      </FilterBar.Item>

      <FilterBar.Item>
        <SelectV2
          mode="single"
          placeholder="Status"
          options={MANAGER_USER_STATUS_OPTIONS}
          value={filters.values.status !== undefined ? String(filters.values.status) : undefined}
          onChange={(next) => filters.setValue("status", next !== undefined ? (Number(next) as ManagerUserStatus) : undefined)}
        />
      </FilterBar.Item>
    </EntityFilterBar>
  );
};

export default ManagerUsersTabFilterBar;
